import contactInfo from './contactInfo';
import personalInfo from './personalInfo';
import professionalInfo from './professionalInfo';
import sensitiveInfo from './sensitiveInfo';
import tabs from './tabs';
export default {
  personalInfo,
  contactInfo,
  sensitiveInfo,
  professionalInfo,
  tabs,
};
